import moment from 'moment';

export function formatDashboardFilterDate(time) {
  return moment(time).format('YYYY-MM-DD');
}



// WEBPACK FOOTER //
// ./src/utils/dashboard/dateFilterFormat.js